///<reference path="../../employee/sections/employee.notes.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class NotesSection extends Meevo.Plugins.Employee.NotesSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherNote;
        }

    }
}